// extracted by css-extract-rspack-plugin
export default {"snackbarContainer":"recommendation-fragment__NotificationSnackbar_snackbarContainer__7mrXL","slide-up":"recommendation-fragment__NotificationSnackbar_slide-up__XuGiE"};